import {FC, useEffect, useRef, useState} from 'react'
import Modal from 'react-bootstrap/Modal'
import * as Yup from 'yup'
import {v4 as uuidv4, validate, version} from 'uuid'
import {nanoid} from 'nanoid'
import {Badge, Form, Button as RButton} from 'react-bootstrap'
import {
  ColumnInvoices,
  InvoiceConfig,
} from '../../interfaces/Invoices'
import {useIntl} from 'react-intl'
import ReactQuill from 'react-quill'
import {convertHtmlToWhatsappFormat} from '../../functions/general'
import clsx from 'clsx'
import Select, { type OptionProps, components } from 'react-select'
import {FormatInvoice} from './FormatInvoice'
import {useFormik} from 'formik'
import moment from 'moment-timezone'
import {formatOptions} from '../../interfaces/Options'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react'
import { useSettingsStore } from '../../stores/SettingsStore'
import { InvoiceVariableOptions } from './InvoiceComponentParts'
import Swal from 'sweetalert2'

const X_DEBUG = false

interface InvoiceModalProps {
  context: 'add' | 'edit'
  typeInvoice: 'all'|'pipeline'|'pipeline-multi-product'|'pipeline-cf'|'pipeline-multi-cf'|'termin-cf'|'merchant-cf'
  item: InvoiceConfig
  setItem: React.Dispatch<React.SetStateAction<InvoiceConfig>>
  showFormDnD: boolean
  handleFormDnDClose: (dnd_type?: 'add' | 'edit') => void
  setItems: any
  column: ColumnInvoices[]
  setPreviewItems?: any
}

export interface regexVariablesProps {
  labelName: string
  id: string
}

export const InvoiceModal: FC<InvoiceModalProps> = ({
  context,
  typeInvoice,
  item,
  setItem,
  showFormDnD,
  handleFormDnDClose,
  setItems,
  column,
  setPreviewItems
}) => {
  const intl = useIntl()

  const {settings} = useSettingsStore()

  const [selectColumn, setSelectColumn] = useState<ColumnInvoices[]>([])

  const [editModalStep, setEditModalStep] = useState<'form' | 'setConfig'>('form')
  const [isCaptionEmpty, setIsCaptionEmpty] = useState<boolean>(true)
  const [isBtnLoading, setIsBtnLoading] = useState<boolean>(context === 'add' ? true : false)
  const [errors, setErrors] = useState<ColumnInvoices[]>([])

  const generateValidationSchema = (fields: ColumnInvoices[]) => {
    const fieldsWithRequired = fields
      .filter((field) => {
        if (typeInvoice === 'all') return true
        if (typeInvoice === 'pipeline') return field.model === typeInvoice
        if (typeInvoice === 'pipeline-multi-product') return ['pipeline', 'pipeline-multi-product', 'pipeline-cf'].includes(field.model ?? 'pipeline')
        if (typeInvoice === 'pipeline-cf') return ['pipeline', 'pipeline-cf', 'pipeline-multi-cf'].includes(field.model ?? 'pipeline')
      })
      .map((field, index) => ({
        ...field,
        required: field.type === 'array' ? false : true,
        // key: `${field.id}`,
      }))
    const schemaFields = fieldsWithRequired.reduce((acc, field) => {
      let validator: Yup.AnySchema = Yup.string()

      if (field.type === 'string' || field.type === 'array') {
        validator = Yup.string().min(1, intl.formatMessage({id: 'FORM.VALIDATION.LEAST_MIN_CHARACTERS'}, {title:field.label, min: 1})).max(50, intl.formatMessage({id: 'FORM.VALIDATION.LEAST_MAX_CHARACTERS'}, {title:field.label, max: 50}))
        // .required(`${field.label} ${intl.formatMessage({id: 'FORM.VALIDATION.REQUIRED'})}`)
      }
      if (field.type === 'number') {
        validator = Yup.string().min(1, intl.formatMessage({id: 'FORM.VALIDATION.LEAST_MIN_CHARACTERS'}, {title:field.label, min: 1})).max(50, intl.formatMessage({id: 'FORM.VALIDATION.LEAST_MAX_CHARACTERS'}, {title:field.label, max: 50}))
        // .required(`${field.label} ${intl.formatMessage({id: 'FORM.VALIDATION.REQUIRED'})}`)
        // validator = Yup.number().typeError(intl.formatMessage({id: 'FORM.VALIDATION.MUST_BE_NUMBER'}, {title:field.label}))
        // .required(intl.formatMessage({id: 'FORM.VALIDATION.REQUIRED'}))
      }
      if (field.type === 'timestamp') {
        validator = Yup.string()
        // validator = Yup.mixed().test('is-date', `${field.label} ${intl.formatMessage({id: 'FORM.VALIDATION.REQUIRED'})}`, (value) => {
        //   return (
        //     (value instanceof Date && !isNaN(value.getTime())) || typeof value === 'string'
        //     // && formatOptions
        //     //   .slice(0, 4)
        //     //   .some((formatOption) => moment(value, formatOption.value, true).isValid())
        //   )
        // })
      }
      if (field.type === 'currency' || field.type === 'currencyString') {
        validator = Yup.string()
        // validator = Yup.mixed().test('is-valid', intl.formatMessage({id: 'FORM.VALIDATION.FIELD_REQUIRED'}, {title:field.label}), (value) => {
        //   return typeof value === 'number' || typeof value === 'string'
        // })
      }

      if (field.required) {
        validator = validator.required(`${field.label} ${intl.formatMessage({id: 'FORM.VALIDATION.REQUIRED'})}`)
      }

      acc[field.id] = validator
      return acc
    }, {} as Record<string, Yup.AnySchema>)

    return Yup.object().shape(schemaFields)
  }

  // const getDefaultValues =
  //   item &&
  //   item.base.content.length > 0 &&
  //   item.base.content
  //     .filter((data) => typeof data === 'object' && data !== null)
  //     .map((data) => {
  //       const key: string = Object.keys(data)[0] as string
  //       const resultVariable: any = data[key as keyof typeof data]
  //       resultVariable.type = key
  //       return {...resultVariable, type: key}
  //     })
  // /*====*/ X_DEBUG && console.log('getDefaultValues', getDefaultValues)

  const getInitialValues = () => selectColumn &&
  selectColumn.length > 0 &&
  selectColumn.reduce((acc: any, column) => {
    // if (acc.length === 0) return
    /*====*/ X_DEBUG && console.log('column', column.label, column.defaultValue)
    acc[column.id] =
      (column.type === 'currency' || column.type === 'number') && (column.defaultValue === 0 || column.defaultValue === '0' || column.defaultValue === '' || column.defaultValue === 'not_set')
        ? '0'
        : (column.defaultValue === null || column.defaultValue === '') && column.type !== 'timestamp' && column.type !== 'currency' && column.type !== 'currencyString'
        ? intl.formatMessage({id: 'INVOICE.DEFAULT_VALUE.NUMBER'}, {title: column.label})
        : (column.defaultValue === null || column.defaultValue === '') && column.type !== 'timestamp' && (column.type === 'currency' || column.type === 'currencyString')
        ? '0'
        : (column.defaultValue === null || column.defaultValue === '') && column.type === 'timestamp'
        ? '---'
        // : (column.defaultValue !== null || column.defaultValue !== '') && column.type === 'timestamp'
        // ? moment.tz(column.defaultValue, String((column.format as FormatTimestampOptions)?.timezone)).utc().toISOString()
        : typeof column.defaultValue === 'undefined'
        ? ''
        : column.defaultValue
    return acc
  }, {})

  const formik = useFormik({
    initialValues:
    getInitialValues() || {},
    enableReinitialize: true,
    validationSchema: generateValidationSchema(selectColumn),
    onSubmit: async (values: Record<string, string>, {resetForm}) => {
      /* ==== */ X_DEBUG && console.log('values', values)
      if (!item.dnd_data.variables) return

      const setDefaultValue: ColumnInvoices[] = []
      const result: any[] = []
      const newErrors: any[] = []

      const handleSource = (source: string) =>
        validate(source) && version(source) === 4 ? 'leadCustomField' : source

      const handleKey = (source: string) =>
        validate(source) && version(source) === 4 ? source : ''

      const typeHandlers: Record<string, (x: ColumnInvoices, value: string) => any> = {
        string: (x, value) => ({
          string: {
            id: x.id,
            index: x.index,
            source: handleSource(x.format!.source),
            key: handleKey(x.format!.source),
            defaultValue: value,
          },
        }),
        number: (x, value) => {
          if (!('fillDigit' in x.format!)) {
            // formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id: 'FORM.LABEL.DIGIT_DISPLAY_LENGTH'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id: 'FORM.LABEL.DIGIT_DISPLAY_LENGTH'})}))
          }

          return {
            number: {
              id: x.id,
              index: x.index,
              source: handleSource(x.format.source),
              key: handleKey(x.format.source),
              fillDigit: x.format!.fillDigit,
              defaultValue: value,
            },
          }
        },
        timestamp: (x, value) => {
          if (value === '---' || value === '' || value === null) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id: 'FORM.LABEL.DEFAULT_VALUE'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id: 'FORM.LABEL.DEFAULT_VALUE'})}))
          }
          if (!('format' in x.format!)) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: 'Format'})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: 'Format'}))
          }

          return {
            timestamp: {
              id: x.id,
              index: x.index,
              source: handleSource(x.format.source),
              key: handleKey(x.format.source),
              format: x.format!.format,
              timezone: x.format!.timezone,
              locale: x.format!.locale,
              // defaultValue: moment.utc(value).toISOString(),
              defaultValue: moment.tz(value, x.format!.timezone).toISOString(),
              value: value,
            },
          }
        },
        currency: (x, value) => {
          // console.log('currencysssss,', x, value)
          if (!('locale' in x.format!)) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_VIEW_CURRENCY'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_VIEW_CURRENCY'})}))
          }

          if (!('currency' in x.format!)) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.CURRENCY_CODE'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.CURRENCY_CODE'})}))
          }

          if (!('currencyType' in x.format!)) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_TYPE_CURRENCY'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_TYPE_CURRENCY'})}))
          }

          if (x.format!.currencyType === 'number') {
            return {
              currency: {
                id: x.id,
                index: x.index,
                source: handleSource(x.format.source),
                key: handleKey(x.format.source),
                locale: x.format!.locale,
                currency: x.format!.currency,
                currencyType: x.format!.currencyType,
                defaultValue: value,
              },
            }
          } else if (x.format!.currencyType === 'string') {
            return {
              currencyString: {
                id: x.id,
                index: x.index,
                source: handleSource(x.format.source),
                key: handleKey(x.format.source),
                locale: x.format!.locale,
                currency: x.format!.currency,
                currencyType: x.format!.currencyType,
                defaultValue: value,
              },
            }
          }
        },
        currencyString: (x, value) => { // UPDATE case
          if (!('locale' in x.format!)) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_VIEW_CURRENCY'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_VIEW_CURRENCY'})}))
          }

          if (!('currency' in x.format!)) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.CURRENCY_CODE'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.CURRENCY_CODE'})}))
          }

          if (!('currencyType' in x.format!)) {
            formik.setErrors({[x.id]: intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_TYPE_CURRENCY'})})})
            throw new Error(intl.formatMessage({id:'INVOICE.FORM.FORM_REQUIRED'}, {title: intl.formatMessage({id:'FORM.LABEL.FORMAT_TYPE_CURRENCY'})}))
          }

          if (x.format!.currencyType === 'number') {
            return {
              currency: {
                id: x.id,
                index: x.index,
                source: handleSource(x.format.source),
                key: handleKey(x.format.source),
                locale: x.format!.locale,
                currency: x.format!.currency,
                currencyType: x.format!.currencyType,
                defaultValue: value,
              },
            }
          } else if (x.format!.currencyType === 'string') {
            return {
              currencyString: {
                id: x.id,
                index: x.index,
                source: handleSource(x.format.source),
                key: handleKey(x.format.source),
                locale: x.format!.locale,
                currency: x.format!.currency,
                currencyType: x.format!.currencyType,
                defaultValue: value,
              },
            }
          }
        },
      }

      item.dnd_data.variables!.forEach((x: ColumnInvoices, i: number) => {
        if (
          !x.format ||
          !x.type ||
          !Object.keys(values).includes(x.id) ||
          !values[x.id] ||
          !x.format.source
        ) {
          newErrors.push({...x, errorMessage: 'Invalid configuration'})
          return
        }

        try {
          const handler = typeHandlers[x.type]
          if (handler) {
            result.push(handler(x, values[x.id]))
          } else {
            throw new Error('Unsupported type')
          }
        } catch (error: any) {
          newErrors.push({...x, errorMessage: error.message})
        }

        return setDefaultValue.push({...x, defaultValue: values[x.id]})
      })

      /* ==== */ X_DEBUG && console.log('newErrors', newErrors)
      if(newErrors.length > 0) {
        setErrors(newErrors)
        return
      }

      /* ==== */ X_DEBUG && console.log('setDefaultValue', setDefaultValue)

      handleSave(true, result, setDefaultValue)
      resetForm()
      handleFormDnDClose()
    },
  })

  const contentRef = useRef<ReactQuill>(null)

  const handleName = (valName: string) => {
    if (valName.length > 20) return
    setItem((prevItem: InvoiceConfig) => ({...prevItem, name: valName}))
  }

  const handleTypeContent = (valContent: string) => {
    if (!contentRef.current) return
    // console.log('valContent', valContent)

    // const editor = contentRef.current.getEditor()
    // const format = editor.getFormat()
    setItem((prevItem: InvoiceConfig) => ({
      ...prevItem,
      dnd_data: {...prevItem.dnd_data, formattedContent: valContent, previewQtyHtml: valContent, content: [valContent]},
    }))
  }

  const handleInsertVariable = (variable: string, id = nanoid(6)) => {
    if (contentRef.current) {
      const editor = contentRef.current.getEditor()
      const range = editor.getSelection(true)
      editor.insertText(range.index, `[${variable}_${id}]`)
    }
  }

  const xhandleSave = (
    isVariables: boolean = false,
    result?: any,
    setDefaultValue?: ColumnInvoices[]
  ) => {
    let i = 0
    setItems((prevItems: InvoiceConfig[]) => {
      const saveNewItems = prevItems.map((currentItem) =>
        currentItem.id === item.id
          ? {
              ...item,
              dnd_data: {
                ...item.dnd_data,
                content: isVariables
                  ? item.dnd_data.content.join('')
                      .split(/(\[.*?\])/g)
                      .map((part: any) => {
                        if (/^\[.*?\]$/.test(part)) {
                          if (part === '[]' || part === null || part === undefined) return '❓❓'
                          if (!result[i]) return '❓❓❓'
                          return result[i++]
                        }
                        if (part === '' || part === null || part === undefined) return ' '
                        return part
                      })
                  : item.dnd_data.content,
                variables: isVariables ? setDefaultValue : [],
              },
            }
          : currentItem
      )
      return saveNewItems
    })
    i = 0

    let j = 0
    if(setPreviewItems) {
      // console.log('setPreviewItems')
      setPreviewItems((prevItems: InvoiceConfig[]) => {
        const saveNewPreviewItems = [...prevItems]
        const index = saveNewPreviewItems.findIndex((currentItem) => currentItem.id === item.id)
        if (index > -1) {
          saveNewPreviewItems[index] = {
            ...item,
            dnd_data: {
              ...item.dnd_data,
              content: isVariables
                ? item.dnd_data.content.join('')
                    .split(/(\[.*?\])/g)
                    .map((part: any) => {
                      if (/^\[.*?\]$/.test(part)) {
                        if (part === '[]' || part === null || part === undefined) return '❓❓'
                        if (!result[j]) return '❓❓❓'
                        return result[j++]
                      }
                      if (part === '' || part === null || part === undefined) return ' '
                      return part
                    })
                : item.dnd_data.content,
              variables: isVariables ? setDefaultValue : [],
            },
          }
        } else {
          saveNewPreviewItems.push({
            ...item,
            dnd_data: {
              ...item.dnd_data,
              content: isVariables
                ? item.dnd_data.content.join('')
                    .split(/(\[.*?\])/g)
                    .map((part: any) => {
                      if (/^\[.*?\]$/.test(part)) {
                        if (part === '[]' || part === null || part === undefined) return '❓❓'
                        if (!result[j]) return '❓❓❓'
                        return result[j++]
                      }
                      if (part === '' || part === null || part === undefined) return ' '
                      return part
                    })
                : item.dnd_data.content,
              variables: isVariables ? setDefaultValue : [],
            },
          })
        }
        return saveNewPreviewItems
      })
    }
    j = 0
  }

  const handleSave = (
    isVariables: boolean = false,
    result?: any,
    setDefaultValue?: ColumnInvoices[]
  ) => {
    let itemIndex = 0
    const invalidVariables= []
    const processContent = (content: string[]) => {
      return content
        .join('')
        .split(/(\[.*?\])/g)
        .map((part: any) => {
          if (/^\[.*?\]$/.test(part)) {
            if (part === '[]' || part === null || part === undefined) return '❓❓'
            if (!result[itemIndex]) {
              // Swal.fire({
              //   title: intl.formatMessage({ id: 'INVOICE.ALERT.ERROR' }),
              //   text: intl.formatMessage(
              //     { id: 'INVOICE.ERROR_BAD_VARIABLE' },
              //     { title: part, total: result.length }
              //   ),
              //   icon: 'error',
              // })
              return '❓❓❓'
            }
            return result[itemIndex++]
          }
          if (part === '' || part === null || part === undefined) return ' '
          return part
        })
    }
  
    const updateItem = (setState: React.Dispatch<React.SetStateAction<InvoiceConfig[]>>) => {
      setState((prevItems) => {
        const updatedItems = [...prevItems]
        const index = updatedItems.findIndex((i) => i.id === item.id)
  
        const newItem = {
          ...item,
          dnd_data: {
            ...item.dnd_data,
            content: isVariables ? processContent(item.dnd_data.content) : item.dnd_data.content,
            variables: isVariables ? setDefaultValue : [],
          },
        }
  
        if (index > -1) {
          updatedItems[index] = newItem
        } else {
          updatedItems.push(newItem)
        }
        return updatedItems
      })
    }
    itemIndex = 0
  
    updateItem(setItems)
    if (setPreviewItems) updateItem(setPreviewItems)
  }
  

  const extractVariables = (item: InvoiceConfig): ColumnInvoices[] => {
    if (item.dnd_data.formattedContent && item.dnd_data.formattedContent.length === 0) return []

    const ArrayFormattedContent = [item.dnd_data.formattedContent!]
    const regex = /\[(.*?)_(.*?)\]/g

    const resultRegex = ArrayFormattedContent.flatMap((text) => {
      const matches: regexVariablesProps[] = []
      let match
      while ((match = regex.exec(text)) !== null) {
        const [fullMatch, labelName, id] = match
        matches.push({labelName, id})
      }
      return matches
    })

    // console.log('resultRegex', resultRegex)

    if (resultRegex.length > 0) {
      let resultVariable: ColumnInvoices[] = resultRegex
        .map((data: regexVariablesProps, index: number) => {
          const field = column.find((f) => f.label === data.labelName) as ColumnInvoices
          // /*====*/ X_DEBUG && console.log('column',column, data.labelName)
          // /*====*/ X_DEBUG && console.log('extractVariables_field', field)
          if (field) {
            const matchedVariable = item.dnd_data.variables?.find((v) => v.id === data.id)
            // /*====*/ X_DEBUG && console.log('matchedVariable',matchedVariable, data.labelName)

            if (matchedVariable) {
              // console.log('phase1')
              return {
                ...field,
                id: matchedVariable.id,
                type: matchedVariable.type,
                index: item.dnd_data.variables?.indexOf(matchedVariable),
                defaultValue: matchedVariable.defaultValue || '',
                format: matchedVariable.format,
              }
            } else {
              // console.log('phase2')
              return {
                ...field,
                id: data.id,
                index: -1,
                defaultValue: '',
              }
            }
          } else {
            // console.log('phase3')
            return null
          }
        })
        .filter(Boolean) as ColumnInvoices[]

      // if (item.dnd_data.variables && item.dnd_data?.variables.length > 0) {
      //   console.log('extractVariables.data', resultVariable)
      //   console.log('extractVariables.item.dnd_data.variables', item.dnd_data.variables)
      // }

      return resultVariable
    } else {
      return []
    }
  }

  useEffect(() => {
    if (item?.dnd_data) {
      if (editModalStep === 'setConfig') {
        // if (item.dnd_data.variables && item.dnd_data?.variables.length > 0) {
        //   if (item.dnd_data.variables[0].defaultValue) setSelectColumn(item.dnd_data.variables)
        // } else setSelectColumn(extractVariables(item))
        const resultVariables = extractVariables(item)
        /*====*/ X_DEBUG && console.log('resultVariables',resultVariables)
        setSelectColumn(resultVariables)
      } else {
        if (item.dnd_data.variables && item.dnd_data?.variables.length > 0) {
          setSelectColumn(item.dnd_data.variables)
        }
        // else {
        //   setSelectColumn([])
        // }
      }
    } else {
      setSelectColumn([])
    }
  }, [editModalStep])

  useEffect(() => {
    // console.log('selectColumn', selectColumn)
    // console.log('cxxaaaaaaa',getInitialValues())
    if (item?.dnd_data)
      setItem((prevItem) => ({
        ...prevItem,
        dnd_data: {
          ...prevItem.dnd_data,
          variables: selectColumn,
        },
      }))
  }, [selectColumn])

  useEffect(() => {
    const formattedContent = item?.dnd_data?.formattedContent || '';
    if (formattedContent.length > 0 && formattedContent !== '<p><br></p>') {
      setIsCaptionEmpty(false);
    } else {
      setIsCaptionEmpty(true);
    }
  }, [item]);

  // ----------------------------------------------- DEBUG -----------------------------------------------
  // useEffect(() => {
  //   console.log('Current values:', formik.values)
  // }, [formik.values])
    
  // useEffect(() => {
  //   console.log('Current Errors:', formik.errors)
  // }, [formik.errors])

  // useEffect(() => {
  //   console.log('Get Validate Errors:', errors)
  // }, [errors])

  // useEffect(() => {
  //   console.log('Current visible:', showFormDnD)
  // }, [showFormDnD])

  // useEffect(() => {
  //   console.log('Current Column:', column, typeInvoice)
  // }, [column])

  return (
    <>
      <Modal
        show={showFormDnD}
        onHide={() => {
          formik.resetForm()
          if(context === 'add') {
            handleFormDnDClose('add')
          } else {
            // console.log('xx', context)
            handleFormDnDClose()
          }
        }}
        backdrop='static'
        onEnter={() => setEditModalStep('form')}
        keyboard={false}
        centered
        size='lg'
      >
        <Modal.Header
          closeButton
          // onClick={() => {
          //   handleFormDnDClose()
          // }}
        >
          <Modal.Title >
            <h1 className='d-flex align-items-center gap-4'>{context === 'edit' ? intl.formatMessage({id:'FORM.LABEL.UPDATE'}) : intl.formatMessage({id:'FORM.LABEL.CREATE'})} Variables{' '}
            {item?.model && (
            <Badge bg="dark">
              {
                // (item.model === 'all') ? 
                // `Pipeline ${intl.formatMessage({id:'FORM.LABEL.VARIABLE'})}`
                // : 
                (item.model === 'pipeline') ? 
                `${settings.pipeline_title} ${intl.formatMessage({id:'FORM.LABEL.VARIABLE'})}`
                : (item.model === 'pipeline-cf') ? 
                `${settings.pipeline_title} ${intl.formatMessage({id:'FORM.LABEL.VARIABLE'})}`
                : (item.model === 'pipeline-multi-product') ? 
                `${settings.pipeline_title} Multi-${intl.formatMessage({id:'MENU.PRODUCTS'})} ${intl.formatMessage({id:'FORM.LABEL.VARIABLE'})}`
                : ''
              }
            </Badge>
            )}
            </h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: '20px',
          }}
        >
          {item && (
            <form
              onSubmit={(e) => {
                formik.handleSubmit(e)
              }}
            >
              {editModalStep === 'form' && (
                <>
                  <label
                    className='form-label fs-6 fw-bolder text-dark required'
                    htmlFor='dnd_name'
                  >
                    {intl.formatMessage({id: 'FORM.LABEL.NAME'})} Item
                  </label>
                  <div className='input-group mb-3 position-relative'>
                    <input
                      id='dnd_name'
                      type='text'
                      value={item.name}
                      className={clsx('form-control form-control-lg')}
                      autoComplete='off'
                      onChange={(e) => handleName(e.target.value)}
                      autoFocus
                    />
                  </div>
                  <label
                    className='form-label fs-6 fw-bolder text-dark required'
                    htmlFor='dnd_content'
                  >
                    {intl.formatMessage({id: 'FORM.LABEL.SENTENCE'})}
                  </label>
                  <div
                    style={{
                      position: 'relative',
                      marginBottom: '50px',
                    }}
                    onKeyDownCapture={(e) => {
                      if (e.code === 'Enter') {
                        e.preventDefault()
                      }
                    }}
                  >
                    <ReactQuill
                      id='dnd_content'
                      theme='snow'
                      value={item.dnd_data.formattedContent}
                      onChange={(content) => {
                        // console.log('content', content)
                        handleTypeContent(content)
                      }}
                      ref={contentRef}
                      modules={{
                        toolbar: [
                          // [{font:["fantasy", "monospace"]}],
                          [{ header: [false] }],
                          // ['code-block'],
                          ['bold', 'italic', 'underline', 'strike'],
                          // [{ color: [] }],
                          // [{align: []}],
                          // [{indent: '-1'}, {indent: '+1'}],
                        ],
                      }}
                      // formats={['font']}
                      style={{height: 200, width: '100%'}}
                      // onBlur={() => formik.setFieldTouched('content', true)}
                      className='link mb-10'
                      onKeyDown={(event: React.KeyboardEvent)=>{
                        if (event.key === "Enter") {
                          event.preventDefault(); // Mencegah Enter
                        }
                        if (event.key === '[' || event.key === ']') {
                          event.preventDefault(); // Mencegah []
                        }
                      }}
                    />

                    <Select
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          border: 'none',
                          backgroundColor: 'none',
                          width: '130px',
                        }),
                        option: (baseStyles, {isSelected, isFocused}) => ({
                          ...baseStyles,
                          backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                          cursor: 'pointer',
                          // width: "150px",
                        }),
                        menuList: (baseStyles, state) => ({
                          ...baseStyles,
                          width: '600px',
                        }),
                        menu: (baseStyles, state) => ({
                          ...baseStyles,
                          width: '600px',
                          right: 5,
                        }),

                        dropdownIndicator: (baseStyles, state) => ({
                          ...baseStyles,
                          display: 'none',
                        }),
                        indicatorSeparator: (baseStyles, state) => ({
                          ...baseStyles,
                          display: 'none',
                        }),
                      }}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary: 'none',
                        },
                      })}
                      components={{ Option: InvoiceVariableOptions }}
                      onChange={(value) => handleInsertVariable(value?.label ?? '')}
                      value={null}
                      className='react-select-styled position-absolute top-0 end-0 mt-1 me-1'
                      classNamePrefix='react-select'
                      options={column.filter((col: any) => {
                        // if (typeInvoice === 'all') return true
                        if (item.model === 'pipeline') return col.model === 'pipeline'
                        if (item.model === 'pipeline-multi-product') return ['pipeline', 'pipeline-multi-product', 'pipeline-cf'].includes(col.model ?? 'pipeline')
                        if (item.model === 'pipeline-cf' || item.model === 'pipeline-multi-cf') return ['pipeline', 'pipeline-multi-cf', 'pipeline-cf'].includes(col.model ?? 'pipeline')
                      })}
                      placeholder={`${intl.formatMessage({
                        id: 'FORM.ACTION.CHOOSE',
                      })} ${intl.formatMessage({
                        id: 'FORM.LABEL.VARIABLE',
                      })}`}
                      isSearchable={true}
                    />
                  </div>
                </>
              )}
              {editModalStep === 'setConfig' && (
                <div>
                  <FormatInvoice
                    context={context}
                    formik={formik}
                    errors={errors}
                    selectColumn={selectColumn}
                    setSelectColumn={setSelectColumn}
                    setIsBtnLoading={setIsBtnLoading}
                    item={item}
                    setItem={setItem}
                  />
                </div>
              )}

              <div style={{display: 'flex', justifyContent: 'center'}}>
                {editModalStep === 'form' && (
                  <>
                    {extractVariables(item).length > 0 ? (
                      <RButton
                        disabled={isCaptionEmpty}
                        type='button'
                        onClick={() => {
                          setEditModalStep('setConfig')
                        }}
                        variant='primary'
                        className=''
                      >
                        {intl.formatMessage({id: 'FORM.ACTION.CONTINUE'})}
                      </RButton>
                    ) : (
                      <RButton
                        // disabled={!formik.isValid || !formik.dirty}
                        disabled={isCaptionEmpty}
                        onClick={() => {
                          handleFormDnDClose()
                          setEditModalStep('form')
                          handleSave()
                        }}
                        variant='primary'
                        className=''
                      >
                        {intl.formatMessage({id: 'FORM.ACTION.SAVE'})}
                      </RButton>
                    )}
                  </>
                )}
                {editModalStep === 'setConfig' && (
                  <div className='d-flex gap-4 mt-4'>
                    <RButton
                      type='button'
                      onClick={() => {
                        setEditModalStep('form')
                        formik.resetForm()
                      }}
                      variant='secondary'
                      className=''
                    >
                      {intl.formatMessage({id: 'FORM.ACTION.BACK'})}
                    </RButton>
                    <RButton
                      disabled={isBtnLoading}
                      type='submit'
                      onClick={() => {
                        // setVisible(false)
                        // setEditModalStep('form')
                        // handleSave()
                      }}
                      variant='primary'
                      className=''
                    >
                      {intl.formatMessage({id: 'FORM.ACTION.SAVE'})}
                    </RButton>
                  </div>
                )}
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}
